import React from 'react';
import { Grid } from "@mui/material";
import { OfferCreatorFilterParams } from "../../../../../model/filter-params/OfferCreatorFilterParams";
import { OnFilterChange } from "../../../../hooks/useTable";
import { ThreeStateSelectFilter } from "../../../../components/form/ThreeStateSelectInput";
import { IdWithName } from "../../../../../model/IdWithName";
import MediumCategoriesFilter from "../../../../components/filter/MediumCategoriesFilter";
import MediumKindsFilter from "../../../../components/filter/MediumKindsFilter";
import ClearFiltersBtn from "../../../../components/ClearFiltersBtn";
import TownsFilter from "../../../../components/filter/TownsFilter";
import VoivodeshipsFilter from "../../../../components/filter/VoivodeshipsFilter";

const Filters: React.FC<FiltersProps> = props => {
    return (
        <Grid container pr={ 2 }>
            <Grid item container xs={ 0.5 } justifyContent='center' alignItems='center'>
                <ClearFiltersBtn
                    onClearFiltersClick={ props.onClearFiltersClick }
                    disabled={ !props.isAnyFilterActive }
                />
            </Grid>
            <Grid item container spacing={ 2 } xs={ 11.5 }>
                <Grid item container columnSpacing={ 2 }>
                    <Grid item container xs={ 1 }>
                        <ThreeStateSelectFilter
                            label='Wybrane'
                            onChange={ value => props.onFilterChange('accepted', value) }
                            value={ props.values?.accepted }
                        />
                    </Grid>
                    <Grid item container xs={ 11 / 4 }>
                        <MediumCategoriesFilter
                            options={ props.filterOptions.mediumCategories }
                            values={ props.values?.mediumCategoryIds }
                            onFilterChange={ props.onFilterChange }
                        />
                    </Grid>
                    <Grid item container xs={ 11 / 4 }>
                        <MediumKindsFilter
                            options={ props.filterOptions.mediumKinds }
                            values={ props.values?.mediumKindIds }
                            onFilterChange={ props.onFilterChange }
                        />
                    </Grid>
                    <Grid item container xs={ 11 / 4 }>
                        <TownsFilter
                            options={ props.filterOptions.towns }
                            values={ props.values?.towns }
                            onFilterChange={ props.onFilterChange }
                        />
                    </Grid>
                    <Grid item container xs={ 11 / 4 }>
                        <VoivodeshipsFilter
                            options={ props.filterOptions.voivodeships }
                            values={ props.values?.voivodeships }
                            onFilterChange={ props.onFilterChange }
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}
export default React.memo(Filters);

export interface FiltersProps {
    readonly values: OfferCreatorFilterParams;
    readonly onFilterChange: OnFilterChange<OfferCreatorFilterParams>;
    readonly filterOptions: OfferCreatorFilterOptions;
    readonly onClearFiltersClick: () => void;
    readonly isAnyFilterActive: boolean;
}

export interface OfferCreatorFilterOptions {
    readonly mediumCategories?: IdWithName[];
    readonly mediumKinds?: IdWithName[];
    readonly towns?: IdWithName[];
    readonly voivodeships?: string[];
}